import { SEARCH_AREA_INPUT_ID } from '../../constants';
import { useSearchContext } from '../../context/Search';

const useVerticalSearchBarLogic = () => {
  const {
    focusedInput: [focusedInput],
  } = useSearchContext();

  const isSearchAreaInputFocused = focusedInput === SEARCH_AREA_INPUT_ID;
  return { isSearchAreaInputFocused };
};

export default useVerticalSearchBarLogic;
